import React from 'react';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import PopupMenu from '../PopupMenu';
import ActionSheet from '../ActionSheet';

const ContextMenu = ({ children }) => {
  const isWideScreen = useIsWideScreen();

  const Wrapper = isWideScreen ? PopupMenu : ActionSheet;

  return <Wrapper>{children}</Wrapper>;
};

export default ContextMenu;
